import { DsplNode } from './dspl-node'
import { Build } from './frontend'
import { RmsWorkerMessagePayload } from './rms-worker'
import { post } from './util'
import { Deferred } from 'everyday-utils'

export type RmsServiceMessagePayload =
  | { onReady: true }

export type RmsService = ReturnType<typeof createRms>

export function createRms(dspl: DsplNode) {
  const url = new URL('./rms-worker.js', import.meta.url).href
  const worker = new Worker(url)

  const deferred = Deferred<void>()

  post<RmsWorkerMessagePayload>(worker, {
    initVm: [DsplNode.vmBinary, dspl.options.memory, dspl.frontend.buffers]
  })

  const service = {
    onReady() { },
    async setBuild(build: Build) {
      await deferred.promise
      post<RmsWorkerMessagePayload>(worker, {
        setCtrl: [
          build.binary,
          build.payload.ins,
          build.payload.outs,
          build.payload.mems,
          build.payload.memsAfter,
          build.payload.memsReset,
        ]
      })
    },
    run(begin: number, end: number) {
      post<RmsWorkerMessagePayload>(worker, {
        run: [begin, end, dspl.frontend.rms.byteOffset]
      })
    }
  }

  worker.onmessage = (e: MessageEvent<RmsServiceMessagePayload>) => {
    if ('onReady' in e.data) {
      // console.log('rms service ready')
      deferred.resolve()
      service.onReady?.()
    }
  }

  return service
}
